<ng-container *ngIf="list && list.length > 0">
  <div class="result-list-container">
    <div class="item-list">
      <div class="item-container"
        *ngFor="let item of list"
        (click)="onSelect(item)"
        [ngClass]="item.selected ? 'selected': ''" >
        <span class="title">
          {{item.title}}
        </span>
        <span *ngIf="item.description" class="subtitle">
          {{item.description}}
        </span>
      </div>
    </div>
  </div>
</ng-container>
